import { useEffect, useRef, useState } from "react";
import styled from "@emotion/styled";
import { MessageRequestDuration } from "../MessageRequestDuration";
import { FadingText } from "@shared/components/FadingText";
import { SparklesIcon } from "@avenue-8/sidekick-ui";

const Container = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;

  span {
    color: ${(p) => p.theme.text.colors.primary};
  }
`;

const IconCircle = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background-color: ${(p) => p.theme.colors.background5};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

type Props = {
  messages?: string[];
  delay?: number;
  displayMessageDuration?: boolean;
};

export const MessageLoading = (props: Props) => {
  const {
    messages = ["Loading..."],
    delay = 4000,
    displayMessageDuration = true,
  } = props;
  const [messageIndex, setMessageIndex] = useState(0);
  const interval = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (messages.length <= 1) return;
    interval.current = setInterval(() => {
      setMessageIndex((prev) => {
        const next = prev + 1;
        if (next >= messages.length - 1) clearInterval(interval.current!);
        return Math.min(next, messages.length - 1);
      });
    }, delay);
    return () => {
      if (!interval.current) return;
      return clearInterval(interval.current);
    };
  }, [messages.length, delay]);

  return (
    <Container>
      <IconCircle>
        <SparklesIcon animated />
      </IconCircle>
      <span>
        <FadingText text={messages[messageIndex]} animate />
      </span>
      {displayMessageDuration && <MessageRequestDuration keepCounting />}
    </Container>
  );
};
